// extracted by mini-css-extract-plugin
module.exports = {"card":"ContentfulCard_card__X7yPB","imageOverlay":"ContentfulCard_imageOverlay__tnccJ","details":"ContentfulCard_details__hlN4j","priceAmount":"ContentfulCard_priceAmount__tEBh3"};